export default __webpack_public_path__ + "static/media/ico-order-active.68039596.svg";